import {
  buildProfileContractSafely,
  PROFILE_KNOWLEDGE_CHAPTERS,
  resolveKnowledgeFactProfileChapterId,
} from '../profileContract';

const getContractFactChapterMap = ({ child = {}, items = [] } = {}) => {
  const { contract } = buildProfileContractSafely({ child, knowledgeFacts: items });
  const chapterByFactId = new Map();

  PROFILE_KNOWLEDGE_CHAPTERS.forEach((chapter) => {
    const groups = contract?.[chapter.domainKey]?.handbook?.groups || [];
    groups.forEach((group) => {
      (group.entries || []).forEach((entry) => {
        if (entry.knowledgeFactId) chapterByFactId.set(entry.knowledgeFactId, chapter.chapterId);
      });
    });
  });

  return chapterByFactId;
};

export const getKnowledgeItemProfileChapterId = (item = {}, representedChapterId = '') => {
  if (representedChapterId) return representedChapterId;
  return resolveKnowledgeFactProfileChapterId(item);
};

export const groupKnowledgeItemsByProfileChapter = ({ child = {}, items = [] } = {}) => {
  const renderedChapterByFactId = getContractFactChapterMap({ child, items });
  const groups = new Map(PROFILE_KNOWLEDGE_CHAPTERS.map((chapter) => [
    chapter.chapterId,
    { ...chapter, id: `subject:${chapter.chapterId}`, items: [] },
  ]));

  items.forEach((item) => {
    const chapterId = getKnowledgeItemProfileChapterId(item);
    const group = groups.get(chapterId);
    if (!group) return;
    const renderedChapterId = renderedChapterByFactId.get(item.id) || '';
    group.items.push({
      ...item,
      profileRepresentation: renderedChapterId
        ? {
          chapterId: renderedChapterId,
          label: groups.get(renderedChapterId)?.label || '',
          profileViewId: groups.get(renderedChapterId)?.profileViewId || '',
        }
        : null,
    });
  });

  return Array.from(groups.values())
    .filter((group) => group.items.length)
    .map((group) => ({
      ...group,
      title: group.label,
      subtitle: `${group.items.length} thing${group.items.length === 1 ? '' : 's'} known`,
    }));
};
